const UserSettings = () => import('@/modules/users/views/UserSettings')
const UserIndex = () => import('@/modules/users/views/UserIndex')

export default [
  {
    path: '/my-users',
    name: 'users.index',
    component: UserIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/settings',
    name: 'users.settings.show',
    component: UserSettings,
    meta: { requiresAuthentication: true }
  }
]
